/** Suffix for column headers and input adornments, mirroring `PRICE_UNIT`. */
export const QUANTITY_UNIT = "MW";

export const kilowattsToMegawatts = (
  kiloWatts: number | undefined
): number | undefined =>
  kiloWatts === undefined || kiloWatts === null ? undefined : kiloWatts / 1000;

export const formatMegawatts = (mw: number | undefined): string | undefined => {
  if (mw === undefined || mw === null) {
    return undefined;
  }
  if (mw === 0) {
    return "0";
  }

  const decimals = mw >= 100 ? 0 : mw >= 1 ? 1 : 2;
  const rounded = Number(mw.toFixed(decimals));
  return rounded === 0 ? "<0.01" : String(rounded);
};
